"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockWithUISettingVisibility = void 0;
var _react = _interopRequireDefault(require("react"));
var mockWithUISettingVisibility = function mockWithUISettingVisibility(Component) {
  var WithUISettingsVisibility = function WithUISettingsVisibility(props) {
    return /*#__PURE__*/_react.default.createElement(Component, props);
  };
  return WithUISettingsVisibility;
};
exports.mockWithUISettingVisibility = mockWithUISettingVisibility;